import { store } from '../store';
import { logout } from '../features/auth/authSlice';
import { clearAccessToken } from './authToken';
import { logoutRequest } from './authApi';
import { clearClientAuthCookies } from './csrf';
import { resetSessionRestore } from './sessionRestore';
import { invalidateSilentRefresh } from './http';

/**
 * Full sign-out: revoke server refresh session (clears HttpOnly cookie), erase
 * the in-memory access token, drop CSRF cookie, and reset auth Redux state.
 * After this, a page refresh must show the sign-in form until login succeeds.
 */
export async function endAuthSession(): Promise<void> {
  await logoutRequest();
  clearAccessToken();
  clearClientAuthCookies();
  resetSessionRestore();
  invalidateSilentRefresh();
  store.dispatch(logout());
}
